// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { createContext, useState } from "react";

import { useAuth } from "../auth";
import { ProfileDrawer } from "./ProfileDrawer";

export const DrawerContext = createContext({});

const DrawerProvider = ({ children }) => {
  const [drawerState, setDrawerState] = useState(false);
  const { userState } = useAuth();

  const toggleDrawer = () => {
    setDrawerState((prevState) => !prevState);
  };

  return (
    <DrawerContext.Provider value={{ toggleDrawer, drawerState }}>
      <ProfileDrawer
        state={drawerState}
        toggleDrawer={toggleDrawer}
        patient={userState?.patientData}
      />
      {children}
    </DrawerContext.Provider>
  );
};

export default DrawerProvider;
